import { useQueryParam } from '@kimaramyz/use-query-params';

import { useClearContextModals } from '@/components/Modal';

import _ErrorPage from './_ErrorPage';

const defaultMessage =
  '서버의 프로그래밍 오류로 인해 페이지를 표시할 수 없습니다.';

const InternalServerErrorPage: React.FC = () => {
  const [code] = useQueryParam('code', { isShallow: true });

  useClearContextModals();

  return (
    <_ErrorPage
      title="페이지를 표시할 수 없습니다."
      description={code ? `${defaultMessage}\n[${code}]` : defaultMessage}
      buttonTo="/task"
      buttonLabel="홈으로"
    />
  );
};

export default InternalServerErrorPage;
